import React from 'react';

const TeamFilter = ({ availableTeams, selectedTeam, onTeamChange }) => {
  return (
    <div className="qrp-team-filter">
      <select
        id="qrp-team-select"
        value={selectedTeam}
        onChange={(e) => onTeamChange(e.target.value)}
        className="qrp-team-select"
      >
        <option value="">Tutte le squadre</option>
        {availableTeams.map(team => (
          <option key={team} value={team}>
            {team}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TeamFilter;